import { CheckmarkCircleFilled } from '@fluentui/react-icons';
import BoardingStructure from '../templates/BoardingStructure';
import {
  Button,
  makeStyles,
  tokens
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import {
  getTheme,
} from '@fluentui/react';
const useStyles = makeStyles({
  label: { fontSize: '15px', fontWeight: 'lighter' },
  value: { fontSize: '18px', fontWeight: 'bold' },
  checkMark: {
    color: tokens.colorPaletteSeafoamBorderActive,
    fontSize: '80px',
  },
});



const Complete = () => {
  const { t } = useTranslation();
  const classes = useStyles()
  const theme = getTheme();

  const gradientBackground = {
    height: '350px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    color: '#ffffff',
    width: '40%',
    borderRadius: '5px',
    boxShadow: theme.effects.elevation8,
    backgroundColor: "#ffffff",
  };



  return (
    <BoardingStructure>
      <div style={gradientBackground} >
        <h1 style={{ fontSize: "25px", marginBottom: "10px", color: "#0078D4" }}>{t("boarding.setupComplete")}</h1>
        <p style={{ fontSize: "17px", marginBottom: "30px", color: "#000000" }}>
          {t("boarding.setUpMessageAlready")}
        </p>
        <CheckmarkCircleFilled className={classes.checkMark} />
        <Button
          appearance="primary"
          style={{ width: "140px", height: "40px", fontSize: "15px", marginTop: "20px" }}
          onClick={() => {
            window.location.href = "/";
          }}
        >
          {t("boarding.letsStart")}
        </Button>
      </div>

    </BoardingStructure >

  );
};

export default Complete;
